module.exports = __webpack_public_path__ + "static/header_title_mobile_en-e23ae9c51e7ebbf61d838059d07e2a5a.png";